import { profile } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useAvailableGrades = (isTeacher) => {
	return useQuery({
		queryKey: ['available-grades'],
		queryFn: () => profile.getAvailableGrades(),
		enabled: isTeacher,
		select: data => data.data
	})
}